export default __webpack_public_path__ + "static/media/02.9e2b0df0.jpg";